import React, { useContext } from 'react';
import { Modal } from 'antd';
import TableForm from './TableForm';
import SettingsPosContext from '../../../contexts/settings-contexts/SettingsPosPage';
import { useTranslation } from 'react-i18next';
const SettingsWorkPlaceModal = () => {
  const { modalOpened, setModalOpened, setSelectedPos, selectedPos } =
    useContext(SettingsPosContext);
  const { t } = useTranslation();
  return (
    <Modal
      transitionName=""
      className="work-places-modal shared-custom-modal"
      width="90%"
      style={{ maxWidth: '742px' }}
      title={
        selectedPos
          ? t('PointsOfSale.updateSalePoint')
          : t('PointsOfSale.addNewSalePoint')
      }
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedPos(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedPos(null);
      }}
      footer={false}
    >
      <TableForm />
    </Modal>
  );
};

export default SettingsWorkPlaceModal;
